// pipe (site scope): the ALWAYS-ON workspace→scope sync, extracted from the retired sidebar
// SiteScopeToggle (owner request 2026-08-02: the left panel keeps only "Sites"). Renders
// nothing; it exists so the module-level scope tracks workspace switches even while no ERP
// screen is open — the cmdk quick search and pickers never fetch under a stale site. Mounted
// where the old toggle sat (RootAppSidebar — mounted once per workspace session, visible or
// not); the VISIBLE switch now lives in the workbench top bar (header-toggle.tsx beside it).
import {
  facilityForWorkspace,
  setAllSites,
  setScopeFacility,
} from '@affine/core/modules/erp/erp-site-scope';
import { useErpSiteMapping } from '@affine/core/modules/erp/use-erp-provisioning';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useService } from '@toeverything/infra';
import { useLayoutEffect } from 'react';

export const SiteScopeWorkspaceSync = () => {
  const mapping = useErpSiteMapping();
  const workspace = useService(WorkspaceService).workspace;
  const facilityId = facilityForWorkspace(mapping, workspace.id)?.id ?? null;
  useLayoutEffect(() => {
    // Entering or switching a workspace defaults to THAT site (non-sticky): reset the all-sites
    // choice so the consolidated view never silently carries across workspaces. `facilityId` is
    // stable while the user stays in one workspace, so toggling all-sites within a workspace
    // does NOT re-fire this reset.
    setScopeFacility(facilityId);
    setAllSites(false);
  }, [mapping?.userId, workspace.id, facilityId]);
  return null;
};
